import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Solicitacao from '../containers/solicitacao';

import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';


import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Fiadores from '../containers/fiadores/fiadores';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#c5ffc2',
            main: '#5DAD58',
            dark: '#1d8a17',
            contrastText: '#fff',
        },
        secondary: {
            light: '#ff7961',
            main: '#f44336',
            dark: '#ba000d',
            contrastText: '#000',
        },
    },
});


export default class App extends React.Component {


    componentDidMount () {
        this.props.getNacionalidade();
    }
    


    render() {

        return (
            <MuiThemeProvider theme={theme}>
                <CssBaseline />
                    
                    
                    <br />
                    <Paper style={{ padding: "20px 10px" }} >
                        {this.props.valueAbaIndex === 0 ? <Solicitacao /> : <Fiadores />}



                        <div style={{
                            display: (this.props.globalError ? "block" : "none"),
                            margin: "20px",
                            padding: "20px",
                            textAlign: "center",
                            backgroundColor: "rgb(255, 209, 209)",
                            color: "red"
                        }}>
                            {this.props.globalError}

                            <Snackbar
                                ContentProps={{
                                    style: {
                                        backgroundColor: "#d32f2f",
                                        color: "#fff"
                                    }
                                }}
                                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                                open={!!this.props.globalError}

                                message={<span id="message-id"> {this.props.globalError}</span>}
                            />
                        </div>
                    </Paper>
              
            </MuiThemeProvider>);
    }


};


// WEBPACK FOOTER //
// ./src/components/app.js